import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import { getVariantItems } from './variantLogics';

export function useNavbar() {
  const [showMenu, setShowMenu] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { isBrowsingAllowedTo, viewAs, privilegesLoading } = useAuthContext();
  const navigate = useNavigate();

  // Appeler getVariantItems avec les valeurs nécessaires et l'état de chargement des privilèges
  const variantItems = getVariantItems(isBrowsingAllowedTo, viewAs, privilegesLoading);

    const handleResize = () => {
        setShowMenu(window.innerWidth < 1280);
    };

    const handleClick = () => {
        if (window.innerWidth < 1280) {
            setShowMenu((prevShowMenu) => !prevShowMenu);
        }
    };

    const isSelected = (path) => window.location.pathname.startsWith(path);

    useEffect(() => {
        setShowMenu(window.innerWidth < 1280);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const showSupport = (isWebVersion) => {
        (!isWebVersion) && handleClick();
    };

    const showProfile = (isWebVersion) => {
        (!isWebVersion) && handleClick();
    };

    const showNotification = (isWebVersion) => {
        (!isWebVersion) && handleClick();
        // TODO show popup for notification
        console.log("TODO show popup for  notification")

    }

    const handleNavItemClick = (path) => {
        navigate(path);
        handleClick();
    };

    return { showMenu, handleClick, variantItems, isSelected, selectedItem, handleNavItemClick, showProfile,showSupport, showNotification };
}
